import { useEffect, useMemo } from 'react';
import { detectLocale } from '../i18n/detectLocale';
import { getPageContent } from '../i18n/pages';
import { getTranslations } from '../i18n/translations';

export function useLocale(pageMeta) {
  const locale = useMemo(() => detectLocale(), []);
  const t = useMemo(() => getTranslations(locale), [locale]);

  useEffect(() => {
    document.documentElement.lang = locale;
    document.title = pageMeta?.title || t.meta.title;

    const description = document.querySelector('meta[name="description"]');
    if (description) {
      description.setAttribute('content', pageMeta?.description || t.meta.description);
    }
  }, [locale, t, pageMeta]);

  return { locale, t };
}

export function usePage(pageKey) {
  const locale = useMemo(() => detectLocale(), []);
  const content = useMemo(() => getPageContent(locale, pageKey), [locale, pageKey]);
  const { t } = useLocale(content.meta);

  return { t, content };
}
